import { useTranslation } from 'react-i18next';

import { FORMAT_COLOR_NAMES, FORMAT_COLORS } from './format';

/**
 * The fixed palette as named options - for the colors that identify a workspace, a database or a
 * table. (The server accepts only these.)
 */
export function usePaletteOptions(): { value: string; label: string }[] {
  const { t } = useTranslation();
  return FORMAT_COLORS.map((value, index) => ({
    value,
    label: t(`databases.palette.${FORMAT_COLOR_NAMES[index] ?? 'gray'}` as 'databases.palette.red'),
  }));
}

/** CSS for a neutral-by-default identification color: absent = no variable, no tint. */
export const identityStyle = (color: string | null, name: string) =>
  color ? ({ [name]: color } as Record<string, string>) : undefined;
